// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"EmbedPopover__srOnly--22O6d","hiddenInput":"EmbedPopover__hiddenInput--DZKhB","root":"EmbedPopover__root--1y0cQ","buttonGroup":"EmbedPopover__buttonGroup--xEFRO"};